import React, { useState } from "react";   
import { useHistory } from "react-router-dom";
import DashboardHeaderMenu from "../HeaderMenu";
 
// import DashboardSide from "../Side";

import { 
    DashboardHeaderContainer,
    DashboardHeaderSide,
    DashboardHeaderSideMobile,
    DashboardHeaderAction,
    DashboardHeaderActionIcon,
    DashboardHeaderHomeIcon,  
} from "./styled"; 
//Aqui deixei somente a logo. Retirei as opcoes de Menu: Inicio, Pesquisar etc.
export default function DashboardHeader({ page }){  
    
    const history = useHistory();
    const navigate = to => history.push(`/${ to }`);

    const pages = [
       // { title:'Menu', link:'dashboard', ref:'home' },
       // { title:'Pesquisar', link:'dashboard/search', ref:'search' },
       // { title:'Meus favoritos', link:'dashboard/favorites', ref:'favorites' },
       // { title:'Para imprimir', link:'dashboard/downloads', ref:'downloads' },
       // { title:'Transformar imagem', link:'dashboard/downloads2', ref:'downloads2' }
    ]

    return ( 
        <> 
            <DashboardHeaderContainer>
                <DashboardHeaderSide>
                    <DashboardHeaderSideMobile>
                        <DashboardHeaderHomeIcon 
                            src={`/icons/home.svg`} 
                            alt="home-icon" 
                            onClick={() => navigate('dashboard')}
                            title="Ir para o Dashboard"
                        />
                        <DashboardHeaderActionIcon 
                            src={`/icons/logo_tiq_chat.png`} 
                            alt="logo-icon" 
                            onClick={() => navigate('dashboard')} // Adicionado o onClick aqui
                            style={{ cursor: 'pointer' }} // Adiciona cursor de pointer
                        />    
                        <DashboardHeaderSide>
                            {
                                pages.map((item, key) => 
                                    <DashboardHeaderAction key={key} active={ page === item.ref } onClick={() => navigate(item.link) }> { item.title } </DashboardHeaderAction> 
                                )
                            }
                        </DashboardHeaderSide>
                    </DashboardHeaderSideMobile> 
                </DashboardHeaderSide>
                {/*  */}
                <DashboardHeaderSide> 
                    <DashboardHeaderMenu />  
                </DashboardHeaderSide>
            </DashboardHeaderContainer> 
            {/* <DashboardSide opened={opened} setOpened={setOpened} />  */}
        </>
    );
}